import React from "react";
import HeaderNavigation from "../../../components/layout/HeaderNavigation";
import * as Animate from "react-reveal";
import BorderGradient from "../../../components/blocks/BorderGradient";

const PartnerHeader = () => {
  return (
    <header className="w-full bg-blue2">
      <HeaderNavigation bgdark={true} />
      <div className="pt-8 md:pt-12 lg:pt-16 pb-20 lg:pb-24 container mx-auto px-4">
        <div className="w-full md:10/12 lg:w-8/12 mx-auto text-center relative">
          <Animate.Fade bottom>
            <h2 className="w-full md:w-11/12 lg:w-10/12 mx-auto text-3xl lg:text-4xl xl:text-5xl leading-relaxed xl:leading-tight font-semibold text-white font-mono py-6">
              Our Partners
            </h2>
            <p className="text-white text-base md:text-lg leading-8 pt-0 xl:pt-6 pb-6 w-full lg:w-11/12 xl:w-9/12 mx-auto">
              The Work we do here at Utiva has been supported, celebrated and
              funded by some of the biggest names out there
            </p>
          </Animate.Fade>
        </div>
      </div>

      <div className="grid grid-cols-3 ">
        <BorderGradient />
      </div>
    </header>
  );
};

export default PartnerHeader;
